var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828D99",
    fillRule: "evenodd",
    d: "M14.706 9.784a.91.91 0 0 1-1.291 1.28l-2.118-2.137c-.86-.867-1.451-1.462-1.952-1.864-.487-.391-.8-.525-1.08-.561a2 2 0 0 0-.53 0c-.28.036-.593.17-1.08.56-.5.403-1.092.998-1.952 1.865l-2.118 2.137a.91.91 0 0 1-1.291-1.28L3.45 7.61c.812-.82 1.476-1.489 2.067-1.964.615-.494 1.239-.851 1.988-.947q.495-.063.99 0c.749.096 1.373.453 1.988.947.591.475 1.255 1.145 2.067 1.964z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowUp as ReactComponent };